// extracted by mini-css-extract-plugin
module.exports = {"arrowDown":"Icons_arrowDown__G8_YS","closeIcon":"Icons_closeIcon__rh4jd"};